import React from 'react';
import Box from '@mui/material/Box';

// Layout wrapper shared by BankFilterToolbar / CardFilterToolbar — the toolbar's
// flex row. Kept presentational so per-tab toolbars only vary their controls.
const ToolbarShell: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 2 }}>{children}</Box>
);

export default ToolbarShell;
